import { Scope } from './profile';

export interface MasterData {
    status: Array<Status>;
    category: Categories;
    program: Array<Program>;
    zoneType: ZoneTypes;
    adminRoles: Array<SpecificRole>;
    categorySignalSource: SignalSources;
    outdatedHorizons: OutdatedHorizon[];
}

export interface Status {
    id: string;
    name: string;
}

export interface Categories {
    [Scope.I3M]: {
        family: Array<Category>;
        parentFamily: Array<Category>;
    };
    [Scope.LOG]: {
        family: Array<Category>;
        parentFamily: Array<Category>;
    };
    [Scope.OVERSIZE]: {
        family: Array<Category>;
        parentFamily: Array<Category>;
    };
    [Scope.ACT]: {
        family: Array<Category>;
        parentFamily: Array<Category>;
    };
    [Scope.CATracking]: {
        family: Array<Category>;
        parentFamily: Array<Category>;
    };
}

export interface ZoneTypes {
    [Scope.I3M]: Array<string>;
    [Scope.LOG]: Array<string>;
    [Scope.OVERSIZE]: Array<string>;
    [Scope.ACT]: Array<string>;
}

export interface SignalSources {
    [Scope.I3M]: Array<string>;
    [Scope.LOG]: Array<string>;
    [Scope.OVERSIZE]: Array<string>;
    [Scope.ACT]: Array<string>;
}

export interface Category {
    id: string;
    name: string;
}

export interface Program {
    id: string;
    name: string;
}

export interface SpecificRole {
    id: string;
    name: string;
}

export enum OutdatedHorizonUnit {
    Minute = 'minute',
    Hour = 'hour',
    Day = 'day',
}

export interface OutdatedHorizon {
    provider: string;
    unit: OutdatedHorizonUnit;
    value: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface UpdateOutdatedHorizonPayload {
    provider: string;
    unit: OutdatedHorizonUnit;
    value: number;
}
